import { FormlyFieldConfig } from '@ngx-formly/core';
import { APPLICATION_FIELD_LABELS } from '@lmc-app/shared/constants/application-field-labels.constant';

/**
 * Find the step label for a given field key
 * Searches through the stepper configuration to locate the parent step
 */
export function findFieldStep(fields: FormlyFieldConfig[], fieldKey: string): string | null {
	// The first field should be the stepper
	const stepper = fields[0];
	if (!stepper?.fieldGroup) return null;

	// Search through all steps
	for (const step of stepper.fieldGroup) {
		if (step.props?.label && searchFieldInGroup(step.fieldGroup, fieldKey)) {
			return step.props.label;
		}
	}
	return null;
}

/**
 * Recursively search for a field key within a field group
 */
function searchFieldInGroup(
	fieldGroup: FormlyFieldConfig[] | undefined,
	targetKey: string
): boolean {
	if (!fieldGroup) return false;

	for (const field of fieldGroup) {
		// Check if this field matches the target key
		if (field.key === targetKey) {
			return true;
		}

		// Recursively search in nested fieldGroups
		if (field.fieldGroup && searchFieldInGroup(field.fieldGroup, targetKey)) {
			return true;
		}

		// Search in fieldArray
		if (field.fieldArray) {
			const fieldArray =
				typeof field.fieldArray === 'function'
					? field.fieldArray(field)
					: field.fieldArray;

			if (fieldArray.fieldGroup && searchFieldInGroup(fieldArray.fieldGroup, targetKey)) {
				return true;
			}
		}
	}

	return false;
}

/**
 * Get field label with step context
 * Returns label in format: "Label (Step)" for fields that need step context
 */
export function getFieldLabelWithStep(
	fields: FormlyFieldConfig[],
	fieldKey: string
): string {
	const step = findFieldStep(fields, fieldKey);
	const baseLabel = APPLICATION_FIELD_LABELS[fieldKey] || fieldKey;
	return step ? `${baseLabel} (${step})` : baseLabel;
}